// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modalbox :v-deep.el-dialog[data-v-3fe67ea3]{min-width:550px}.container[data-v-3fe67ea3]{min-width:821px}.dialogBox[data-v-3fe67ea3]{-webkit-box-sizing:border-box;box-sizing:border-box}.dialogBox .el-pagination[data-v-3fe67ea3]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;margin-top:25px}[data-v-3fe67ea3] .el-card__header{padding:18px 20px 0}", ""]);
// Exports
module.exports = exports;
